import { ChainId } from '../../sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.POM]: '0x4C52616e0870DAb2BdE9FA811bea43307E06A403',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
